'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scope = undefined;

var _ramda = require('ramda');

var _scope = require('../const/scope');

var _formatting = require('./formatting');

// Note: When called as a template-literal, a the argument to a function will be
// wrapped in an array, so we need to extract it using head.
// eslint-disable-next-line import/prefer-default-export
var scope = exports.scope = function scope(strings) {
  for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  return (0, _ramda.pipe)(_ramda.zip, (0, _ramda.append)((0, _ramda.last)(strings)), _ramda.flatten, _formatting.joinWithNoSpace, (0, _ramda.objOf)(_scope.SCOPE))(strings, values);
};


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/utils/scope.js
// module id = 683
// module chunks = 168707334958949